import { Checkbox, Input, TableTdInfo } from "best-common-react";
import React from "react";
import styled from "styled-components";
import UserAllotmentConstants from "../../constants/UserAllotmentConstants";
import { AllotmentDTO } from "../../types/Allotment";
import { RequestTypeDesc } from "../../types/RequestType";
import { Season } from "../../types/Season";

const AllotmentInput = styled.div`
  margin-right: 1rem;
  width: 3rem;
`;

const EditableTableData = styled.td`
  width: 35%;
  &&& {
    vertical-align: middle;
  }
`;

const Allotment = ({ value, index, type, changeAllotment }) => {
  const key = "allotment" + index + type + "amount";
  return (
    <EditableTableData>
      <div className="d-flex align-items-center">
        {!value.unlimited && (
          <AllotmentInput>
            <Input
              id={key}
              type="number"
              key={`input-${key}`}
              disabled={value.unlimited}
              value={value.amount}
              onChange={(newVal) => {
                changeAllotment(index, type, value.unlimited, !!newVal ? parseInt(newVal) : 0);
              }}
            />
          </AllotmentInput>
        )}
        <Checkbox
          id={`checkbox-${key}`}
          key={`checkbox-${key}`}
          label="unlimited"
          checked={value.unlimited}
          onChange={() => {
            changeAllotment(index, type, !value.unlimited, value.amount);
          }}
        />
      </div>
    </EditableTableData>
  );
};

type UserAllotmentBulkUpdateTrProps = {
  changeAllotment: (index: number, type: RequestTypeDesc, unlimited: boolean, amount: number | undefined) => void;
  allotments: AllotmentDTO[];
  season: Season;
  index: number;
};

const UserAllotmentBulkUpdateTr = ({ allotments, season, index, changeAllotment }: UserAllotmentBulkUpdateTrProps) => {
  const personalAllotment = allotments && allotments[index] ? allotments[index][UserAllotmentConstants.PERSONAL] : {};
  const businessAllotment = allotments && allotments[index] ? allotments[index][UserAllotmentConstants.BUSINESS] : {};
  return (
    <tr key={"allotment-table-row-" + index}>
      <TableTdInfo>{season && season.seasonType ? season.seasonType.seasonTypeName : ""}</TableTdInfo>
      <>
        <Allotment
          value={personalAllotment}
          index={index}
          type={UserAllotmentConstants.PERSONAL}
          changeAllotment={changeAllotment}
        />
        <Allotment
          value={businessAllotment}
          index={index}
          type={UserAllotmentConstants.BUSINESS}
          changeAllotment={changeAllotment}
        />
      </>
    </tr>
  );
};

export default UserAllotmentBulkUpdateTr;
